module.exports = __webpack_public_path__ + "img/s.75855453.webp";